import apiService from "../../services/api.service";
import { createSlice } from "@reduxjs/toolkit";
import { createApiThunk } from "../../helpers/create.api.thunk";
import { createApiCase } from "../../helpers/create.api.case";

export const addCart = createApiThunk("addCart", apiService.addCart);
export const getCartInfo = createApiThunk(
  "getCartInfo",
  apiService.getCartInfo
);
export const updateCart = createApiThunk("updateCart", apiService.updateCart);
export const removeCart = createApiThunk("removeCart", apiService.removeCart);

export const checkout = createApiThunk("checkout", apiService.checkout);
export const getPaymentList = createApiThunk(
  "getPaymentList",
  apiService.getPaymentList
);

export const initialData = {
  addCartLoading: false,
  cartInfoLoading: false,
  updateCartloading: false,
  removeCartloading: false,
  checkoutLoading: false,
  paymentListLoading: false,

  state: "Kuala Lumpur",
  cartInfo: {
    // total_item: 2,
    // subtotal: 220.0,
    // shipping: 0,
    // tax: 0,
    // total: 220.0,
    // items: [
    //   {
    //     id: 1,
    //     image: Sample,
    //     label: "Black T-Shirt & Trouser",
    //     option: "White | 2XL",
    //     price: 110.0,
    //     quantity: 1,
    //   },
    //   {
    //     id: 2,
    //     image: Sample,
    //     label: "Black T-Shirt & Trouser",
    //     option: "White | 2XL",
    //     price: 110.0,
    //     quantity: 1,
    //   },
    // ],
  },
  paymentList: {},
};

const dataSlice = createSlice({
  name: "cart",
  initialState: initialData,
  reducers: {
    setState: (state, action) => {
      state.state = action.payload;
    },
  },
  extraReducers: (builder) => {
    createApiCase(builder, addCart, {
      loading: "addCartLoading",
    });
    createApiCase(builder, getCartInfo, {
      loading: "cartInfoLoading",
      fulfilled: (state, action) => {
        state.cartInfo = action.payload.data;
      },
    });
    createApiCase(builder, updateCart, {
      loading: "updateCartLoading",
    });
    createApiCase(builder, removeCart, {
      loading: "removeCartLoading",
    });
    createApiCase(builder, checkout, {
      loading: "checkoutLoading",
    });
    createApiCase(builder, getPaymentList, {
      loading: "paymentListLoading",
      fulfilled: (state, action) => {
        state.paymentList = action.payload.data;
      },
    });
  },
});

export const { setState } = dataSlice.actions;

export default dataSlice.reducer;
